import { useState } from "react"

import { Button, Col, Modal, Row } from "react-bootstrap"
import { toast } from "react-toastify"
import { finalize } from "rxjs/operators"

import OrphanedRow from "../../../api/OrphanedResults/Models/OrphanedRow"
import PendingDrugTest from "../../../api/OrphanedResults/Models/PendingDrugTest"
import {
  NoMatchingCreateNewObservable,
  NoMatchingRandomAcceptObservable,
} from "../../../api/OrphanedResults/ResultExceptionsProcess"
import FormatError from "../../../formatters/FormatError"
import { DraggableModalDialog } from "../../Randomization/GovPools/RandomSchedulingExclusionsModal"
import DonorNotFoundError from "../DonorNotFoundError/DonorNotFoundError"

import PendingDrugTests from "../PendingDrugTests/PendingDrugTests"
import PendingDrugTestsButtons from "../PendingDrugTests/PendingDrugTestsButtons"

interface NoMatchingRandomErrorProps {
  errorRow: OrphanedRow
  onClose: (withUpdate: boolean) => void
}

function NoMatchingRandomError(props: NoMatchingRandomErrorProps) {
  const { errorRow, onClose } = props

  const [selectedTest, setSelectedTest] = useState<PendingDrugTest>()
  const [acceptProc, setAcceptProc] = useState(false)
  const [createNewProc, setCreateNewProc] = useState(false)
  const [showDonorNotFound, setDonorNotFound] = useState(false)
  const [hideModal, setHideModal] = useState(false)

  const onCancel = () => {
    onClose(false)
  }

  const onAccept = () => {
    if (!selectedTest) {
      return
    }
    setAcceptProc(true)
    NoMatchingRandomAcceptObservable(errorRow, selectedTest)
      .pipe(finalize(() => setAcceptProc(false)))
      .subscribe(
        (data) => {
          toast.success(data)
          onClose(true)
        },
        (error) => toast.error(FormatError(error))
      )
  }

  const onCreateNew = () => {
    setCreateNewProc(true)
    NoMatchingCreateNewObservable(errorRow)
      .pipe(finalize(() => setCreateNewProc(false)))
      .subscribe(
        (data) => {
          toast.success(data)
          onClose(true)
        },
        (error) => toast.error(FormatError(error))
      )
  }

  const onChangeDonor = () => {
    setHideModal(true)
    setDonorNotFound(true)
  }

  const onCloseDonorNotFound = () => {
    setDonorNotFound(false)
    onClose(true)
  }

  return (
    <>
      {!hideModal && (
        <Modal
          dialogAs={DraggableModalDialog}
          backdrop="static"
          show
          size="xl"
          dialogClassName="dark"
          onHide={() => onClose(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>No Matching Random Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>Review the current Donors Pending tests and determine if there is a match or create a new test.</Col>
            </Row>
            <PendingDrugTests
              donorId={errorRow.PersonID}
              importTest={errorRow}
              selectedTest={selectedTest}
              onSelectTest={setSelectedTest}
            />
          </Modal.Body>
          <Modal.Footer>
            <PendingDrugTestsButtons
              selectedTest={selectedTest}
              disabled={createNewProc || acceptProc}
              acceptSpin={acceptProc}
              createNewSpin={createNewProc}
              onCancel={onCancel}
              onAccept={onAccept}
              onCreateNew={onCreateNew}
            />
            <Button variant="secondary" onClick={onChangeDonor}>
              Change Donor
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {errorRow && showDonorNotFound && <DonorNotFoundError errorRow={errorRow} onClose={onCloseDonorNotFound} />}
    </>
  )
}

export default NoMatchingRandomError
